export const uk = {
    about: 'Подробнее'
};
